import { Map as iMap } from 'immutable';
const initialState = iMap({
  apiUrl: null,
  domainUrl: null,
  version: null,
  locale: 'en-US',
  firstFrameLoad: false,
});

export function config(state = initialState, action) {
  switch (action.type) {
    case 'FIRST_FRAME_LOAD':
      return state.set('firstFrameLoad', true);
    case 'CLEAR_STORES':
    case 'LOG_OUT':
      return state.set('firstFrameLoad', false);
    case 'GET_CONFIG':
      return state.merge(action.config);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/config/config-reducer.js